import { useState } from 'react';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';

export function NicknameModal() {
  const { updateProfile } = useAuth();
  const { t } = useI18n();
  const nm = t.nicknameModal as any;
  const [nickname, setNickname] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    const trimmed = nickname.trim();
    if (!trimmed || trimmed.length < 2) { setError(nm.tooShort); return; }
    setSaving(true);
    setError('');
    try {
      await updateProfile({ nickname: trimmed });
    } catch {
      setError(nm.saveFailed);
      setSaving(false);
    }
  };

  return (
    <div className="nickname-modal-backdrop">
      <div className="nickname-modal-card">
        <h2 className="nickname-modal-title">{nm.title}</h2>
        <p className="nickname-modal-sub">{nm.subtitle}</p>
        <input
          className="nickname-modal-input"
          type="text"
          placeholder={nm.placeholder}
          value={nickname}
          onChange={e => setNickname(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSave()}
          maxLength={50}
          autoFocus
        />
        {error && <p className="nickname-modal-error">{error}</p>}
        <button className="nickname-modal-btn" onClick={handleSave} disabled={saving || !nickname.trim()}>
          {saving ? '...' : nm.continueBtn}
        </button>
      </div>
    </div>
  );
}
